import { useEffect, useRef } from 'react';

export function useSyncedInputValue(value: string) {
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (inputRef.current && inputRef.current.value !== value) {
            inputRef.current.value = value;
        }
    }, [value]);

    return inputRef;
}
